import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Cinema, FilmeExtraido } from '../models/cinema';

@Injectable({
  providedIn: 'root'
})
export class CinemaService {

  private api = '/api/cinema';

  constructor(private http: HttpClient) { }

  getAll(): Observable<Cinema[]> {
    return this.http.get<Cinema[]>(this.api);
  }

  getById(id: number): Observable<Cinema> {
    return this.http.get<Cinema>(`${this.api}/${id}`);
  }

  create(model: Cinema): Observable<Cinema> {
    return this.http.post<Cinema>(this.api, model);
  }

  update(model: Cinema): Observable<void> {
    return this.http.put<void>(`${this.api}/${model.id}`, model);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  extrair(url: string): Observable<FilmeExtraido> {
    return this.http.get<FilmeExtraido>(`${this.api}/extrair`, { params: { url } });
  }

  upload(file: File): Observable<{ fileServerName: string }> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<{ fileServerName: string }>(`${this.api}/upload`, formData);
  }
}
